export default "__VITE_ASSET__YrZT$x2a__"